import ApiService from '@/services/apiService';
import { EventBus } from '@/services/eventbus.js';
import EditMixin from '@/components/core/dtwin/editMixin';
export default {
  name: 'ViewPublicTiles',
  mixins: [EditMixin],
  data() {
    return {
      apiKeyError: false,
      apiKey: null,
      twinId: null,
      counter: 0,
      twinDataStates: [],
      updatedStates: [],
      footerData: {
        de: {},
        en: {}
      }
    };
  },
  async created() {
    this.apiKey = this.$route.params.key;
    this.twinId = this.$route.params.id;
    ApiService.instance.interceptors.request.use(config => {
      config.headers['X-API-Key'] = this.apiKey;
      return config;
    });
    try {
      await this.$store.dispatch('authentication/verify', this.apiKey);
      const isShared = await ApiService.digitalTwinIsShared(this, this.twinId).then(res => {
        return res.isShared;
      }).catch(error => {
        console.error(error);
      });
      if (!isShared) {
        throw new Error('TWIN_SHARING_NOT_ENABLED');
      }
      if (!this.$store.state.app.permissions) {
        await this.$store.dispatch('app/loadPermissions');
      }
      EventBus.$emit('refresh-branding');
    } catch (e) {
      this.apiKeyError = true;
    }
    if (!this.apiKeyError) {
      ApiService.digitalTwinFetchStates(null, this.twinId).then(result => {
        this.twinDataStates = result.map(state => {
          return Object.assign({}, state, {
            title: state.properties.title,
            unit: state.properties.unit
          });
        });
      }).catch(error => {
        this.apiKeyError = true;
        console.error(error);
      });
    }

    // Get Footer Data for Datenschutzhinweis and Impress
    this.footerData = this.$store.state.app.footer;
  }
};